import { useState, useEffect, useCallback } from 'react';
import { mintRewardsApi } from '../api/mint-rewards';
import type { ContestView } from '../api/sweepstakes';

/**
 * Hook to fetch the active/recent mint rewards contest for a launch.
 */
export function useLaunchMintRewards(launchId: string | undefined) {
  const [contestView, setContestView] = useState<ContestView | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchContest = useCallback(async () => {
    if (!launchId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await mintRewardsApi.getForLaunch(launchId);
      setContestView(data.contest ? data as ContestView : null);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [launchId]);

  useEffect(() => {
    fetchContest();
  }, [fetchContest]);

  return { contestView, loading, error, refetch: fetchContest };
}
